inherit("Pages/Landing", {
	parent: `Page`,
	requires: [`User`, `Events`],
	defaults: {
		render: true,
		show: true,
		transition: `fade`,
	},
	async prepare(setup) {
		const { DOM, Events, container, data } = this;

		// the JSP prerenders markup into the container, so Module's own "hide if empty"
		// check (Module.js) never fires here; force it so the header/hero/carousels
		// don't flash while the constructor rebuilds them
		DOM.hide({ target: container, transition: `none`, done: true });

		const { topics } = setup;
		const title = `Tixr | Buy Tickets for Music, Sports, Festivals, Tours, Conferences and more`;
		const heroEvents = await Events.getFeatured();

		this.assign(data, { heroEvents, title, topics });
	},
	async constructor(setup) {
		const { data } = this;
		const { heroEvents, topics } = data;

		const promises = [];
		let promise;

		promise = this.create({
			namespace: `Modules/PageHeader`,
			setup: {
				prerendered: setup.prerendered,
				name: `page-header`,
				showMobileLogin: true,
				showSearch: true,
				showUserLinks: false,
			},
		});
		promises.push(promise);

		promise = this.create({
			namespace: `Modules/PageFooter`,
			setup: {
				prerendered: setup.prerendered,
				name: `page-footer`,
			},
		});
		promises.push(promise);

		promise = this.create({
			namespace: `Modules/Hero`,
			setup: {
				name: `hero`,
				items: heroEvents,
			},
		});
		promises.push(promise);

		const carousels = this.map(topics, (topic) => {
			const { carousel } = topic;
			const orientation = carousel.layout === `FLYER` ? `PORTRAIT` : `LANDSCAPE`;
			// convert to the expected format for Carousel items
			const items = this.map(carousel.items, (item) => ({
				blurb: item.details,
				externalUrl: item.link,
				imageUrl: item.imageUrl,
				hoverMessage: item.hoverMessage,
				title: item.name,
				type: `LINK`,
			}));

			// convert to expected format for Carousel
			return {
				title: topic.name,
				layout: `SINGLE_ROW`,
				orientation,
				mobileLayout: `SINGLE_ROW`,
				mobileOrientation: orientation,
				items,
			};
		});

		promise = this.create({
			namespace: `Modules/CarouselList`,
			setup: {
				name: `carousel-list`,
				carousels,
				mode: `ux3`,
				lazyLoad: false,
			},
		});
		promises.push(promise);

		promise = this.create({
			namespace: `Modules/SocialFeed`,
			setup: {
				name: `social-feed`,
			},
			then: () => {
				this.show({ target: this.get(`.content.social-feed`) });
			},
		});
		promises.push(promise);

		await Promise.all(promises);
	},
});

define("Pages/Landing.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Pages/Landing/main"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<header class=\"head\"> <div name=\"page-header\"></div> <div class=\"scroll-head-background\"></div> </header> <main class=\"body\"> <div class=\"content hero\"> <div name=\"hero\"></div> </div> <div class=\"content carousels\"> <div name=\"carousel-list\"></div> </div> <div class=\"content social-feed\" style=\"display:none\"> <h2>Socials</h2> <div name=\"social-feed\" class=\"transition-content\"></div> </div> <div class=\"content footer\"> <div name=\"page-footer\"></div> </div> </main>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Landing.js.map